import React from "react";

const ListDisplayContext = React.createContext({
    brandsGroups: [],
    availableOptions: {
      countries: [],
      brands: [],
      brandsInCountries: []
    },
    selectedBrand: null,
    setAvailableOptions: () => {}
});

export default ListDisplayContext;
